import React from 'react';
import ContentLoader from 'react-content-loader';
import styled from 'styled-components';

const ThankYouAndOccasionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--size-24);
`;

const ThankYouAndOccasionsSection = styled.div`
  background: var(--color-bg-default);
  border-radius: 8px;
  height: fit-content;
  padding: var(--size-24);
  width: 100%;
`;

const ThankYouLoader = styled(ContentLoader)`
  height: 240px;
  width: 100%;
`;

const OccasionsLoader = styled(ContentLoader)`
  height: 420px;
  width: 100%;
`;

const ThankYouAndOccasions = () => (
  <ThankYouAndOccasionsWrapper>
    <ThankYouAndOccasionsSection>
      <ThankYouLoader speed={2}>
        {[0, 1, 2].map((_, index) => {
          const yOffset = 50 + index * 60;
          return (
            <React.Fragment key={index}>
              <circle cx="16" cy={yOffset + 16} r="16" />
              <rect x="44" y={yOffset + 24} rx="4" ry="4" width="240" height="16" />
            </React.Fragment>
          );
        })}
      </ThankYouLoader>
    </ThankYouAndOccasionsSection>

    <ThankYouAndOccasionsSection>
      <OccasionsLoader speed={2}>
        <rect x="0" y="0" rx="4" ry="4" width="80" height="20" />
        <rect x="right" y="0" rx="4" ry="4" width="80" height="16" />
        {['January', 'February', 'March'].map((_, monthIndex) => {
          const monthY = 50 + monthIndex * 120;
          return (
            <React.Fragment key={monthIndex}>
              <rect x="0" y={monthY} rx="4" ry="4" width="60" height="16" />

              {[0, 1].map((_, dateIndex) => {
                const dateY = monthY + 30 + dateIndex * 40;
                return (
                  <React.Fragment key={`${monthIndex}-${dateIndex}`}>
                    <rect x="0" y={dateY} rx="4" ry="4" width="32" height="32" />

                    <rect x="44" y={dateY + 4} rx="4" ry="4" width="180" height="24" />

                    <rect x="right" y={dateY + 8} rx="4" ry="4" width="16" height="16" />
                  </React.Fragment>
                );
              })}
            </React.Fragment>
          );
        })}
      </OccasionsLoader>
    </ThankYouAndOccasionsSection>
  </ThankYouAndOccasionsWrapper>
);

export default ThankYouAndOccasions;
